import { Fragment } from "react";
import { useTrans } from "~/hooks/useTrans";

interface IInternalDescription {
	desc: string;
}

export default function InternalDescription({
	desc,
}: IInternalDescription) {
	const { trans } = useTrans();
	const showDesc = desc || trans("empty");
	const parts = showDesc.split("\n");

	/* eslint-disable react/no-array-index-key */
	return <>
		{ parts.map((part, ind) => <Fragment key={ind}>
			{ part }
			{ ind !== parts.length && <br /> }
		</Fragment>) }
	</>;
}
